export const formatDate = (date: Date): string => {
  // Format: Month Day, Year
  return new Date(date).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
}; 